import React from 'react'

import { formatCurrency, formatNumber } from '../../lib/format-number'
import { getDmp, getDmpProduct, uniqueDmps } from '../../lib/format-dmps'


const SummaryRevenueRow = ({ property, groupBy }) => (
    <tr className="revenue-list revenue-list--header">
        {/*<td className="revenue-list revenue-list--property">{property.creation}</td>*/}
        {groupBy === false && (
            <td className="revenue-list revenue-list--property">{property.audienceId}</td>
        )}
        <td className="revenue-list revenue-list--property">{getDmp(property.marketplace)}</td>
        <td className="revenue-list revenue-list--property">{property.buyerName}</td>
        <td className="revenue-list revenue-list--property">{property.advertiserName}</td>
        
        <td className="revenue-list revenue-list--revenue">{formatNumber(property.impressions)}</td>
        
    </tr>
)

export default SummaryRevenueRow
